export default [
  {
    path: '/initial-balance/:key?',
    name: 'InitialBalanceIndex',
    component: () => import('@/views/initialBalance/InitialBalanceIndex.vue'),
    meta: {},
  },
];
